import * as types from './mutation-types'
import util from '@/util'

export default {

  [types.SET_FILTROS] (state, { contexto, filtros }) {
    if (!state.filtros[contexto]) {
      state.filtros[contexto] = '{}'
    }
    state.filtros[contexto] = JSON.stringify(filtros)
  },
  [types.LIMPAR_FILTROS] (state, contexto = null) {
    if (util.valorVazio(contexto)) {
      state.filtros = {}
      return
    }

    state.filtros[contexto] = '{}'
  },
  [types.SET_ORDENACAO] (state, { contexto, ordenacao }) {
    if (!state.ordenacao[contexto]) {
      state.ordenacao[contexto] = '{}'
    }
    state.ordenacao[contexto] = JSON.stringify(ordenacao)
  },
  [types.LIMPAR_ORDENACAO] (state, contexto = null) {
    if (util.valorVazio(contexto)) {
      state.ordenacao = {}
      return
    }

    state.ordenacao[contexto] = '{}'
  }

}
